import Webview from "../../../component/native/visible/Webview";
import StoreKitView from "../../../component/native/visible/StoreKitView";
import App from "../../../App";
import MiniEndCardTemplate from "../../MiniEndCardTemplate";
import {RewardJsInstall} from "../../../../api";

export default class MiniEndCardDemo extends MiniEndCardTemplate {
    constructor(...props) {
        super(...props)
        this.name = 'MiniEndCardDemo'
    }


    initComponents() {
        super.initComponents()
    }

    bindPageEvent() {
        super.bindPageEvent()

        const installBtn = document.querySelector('.mtg_install_btn')
        const closeBtn = document.querySelector('.mtg_close_btn')
        if(closeBtn){
            closeBtn.addEventListener('click' , ()=>{
                console.log('关闭按钮被点击+',App, )
                /*this.hide().then(()=>{
                    App.broadcast('miniEndCardClosed', {
                        campaignId: this.campaign && this.campaign.id || false,
                        campaign: this.campaign
                    })
                })*/
                App.emitMessage('miniEndCardClosed', {
                    action: 'miniEndCardClosed'
                })
            },false)
            /*closeBtn.onclick = function(){
                console.log('关闭按钮被点击 onclick')
            }*/
            /*document.documentElement.addEventListener('click' , ()=>{
                console.log('endCard被点击')
            },false)*/
        }
        App.onWebviewPostMessage((data)=>{
            console.log(data)
            if(data && data.action==='close'){
                this.hide()
            }
        })

        if(installBtn){
            installBtn.addEventListener('click' , ()=>{
                console.log('安装按钮被点击+',App,this.container,this.campaign,this)
                const storeKit = new StoreKitView({
                    campaign: this.campaign,
                    unitId: this.unit.id
                })
                storeKit.appendTo(this.container)
                RewardJsInstall(this.campaign)
            },false)
        }

        document.addEventListener('testEvent', (event)=>{
            console.log('========================》 webviewFireEvent 被触发 ',event)
        },false)

    }

    /**
     * 绑定native组件各个事件
     */
    bindNativeEvent() {
    }

    initSlots() {
        super.initSlots()
        //this.slotIn('slot_2', this.playerView)
    }
}